<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true" (onHide)="onClose()"
    [style]="{ width: '90vw', maxWidth: '500px' } ">


    <div class=" bg-gray-20 border-gray-300 lg:space-x-4 pt-1">

        <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-4  sm:px-10">

            <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">Bid Status</h2>

            <p class="text-sm mt-2  font-mulish font-semibold  text-white">Understanding how bids work is key to making
                informed decisions during an auction. Below is a breakdown of each possible bid status—what it means,
                how it
                affects your standing, and what to expect as the auction progresses.</p>
        </div>
        <div class="flex flex-col md:flex-row w-full gap-4 mt-4 text-sm">
            <div class="rounded-lg bg-white shadow-md text-center mt-2 pb-4 ">
                <div class="space-y-2 space-x-2 mt-2 mr-6">

                    <h2 class=" text-lg font-bold  font-mulish text-left">Straight Bid</h2>
                    <p class="font-mulish text-left text-gray-600">
                        When you choose <span class="font-bold">"Bid exactly this amount"</span>, you're placing a
                        Straight
                        Bid. With a
                        Straight Bid, the
                        system places your bid at that exact amount.
                    </p>

                    <p class=" text-lg font-bold  font-mulish text-left text-gray-600">Example:</p>

                    <p class="font-mulish text-left text-gray-600">
                        If the current high bid is $1 and you place a Straight Bid of $15, you immediately become the
                        leading bidder at $15.
                    </p>

                    <p class="font-mulish text-left text-gray-600">
                        With Proxy Bidding ("<span class="italic">Bid up to this amount</span>"), you'd become the
                        leading
                        bidder at $2, with your maximum bid set at $15.
                    </p>


                </div>
            </div>
        </div>
        <div class="px-4">
            <button pButton
                class=" h-[40px] p-button-info rounded-m w-full relative flex items-center justify-center mt-8 "
                (click)="onClose()" [rounded]="true">
                <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>
                <span class="font-semibold text-white text-center w-full text-base">
                    Done
                </span>
            </button>
        </div>
    </div>
</p-dialog>